import { useSellarUser } from "../../hooks";
import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../modal/Dialog";
import { BestPricePromiseFullSize } from "./BestPricePromise";

export const BestPricePromiseDialog = ({
  active,
  onDismiss,
  buyerName,
  supplierName,
  productName,
  isStorefront,
}: {
  active: boolean;
  onDismiss: () => void;
  buyerName?: string | null;
  supplierName?: string | null;
  productName?: string | null;
  isStorefront?: boolean;
}) => {
  const { user } = useSellarUser();
  const defaultFormValue = "xxxxx";
  const typeformUrl = isStorefront
    ? "https://sellar.typeform.com/to/aN2C1sdO#"
    : "https://sellar.typeform.com/to/nTVyikNl#";
  const url = [
    typeformUrl,
    "user_email=",
    user?.email ? user.email : defaultFormValue,
    "&retailer_name=",
    buyerName ? buyerName : defaultFormValue,
    "&supplier_name=",
    supplierName ? supplierName : defaultFormValue,
    ...(!isStorefront
      ? ["&product_name=", productName ? productName : defaultFormValue]
      : []),
  ]
    .filter(Boolean)
    .join("");
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Sellar's Best Price Promise"}
      />
      <DialogContent className={"flex flex-col gap-2"}>
        <div className="flex flex-col gap-2 rounded-md border p-4">
          <BestPricePromiseFullSize
            showHoverAnimation={false}
            showToolTip={false}
          />
          <p>
            When you're ordering on Sellar, you are ordering directly with your
            suppliers. This means they can offer you the best price. See a
            better price? Let us know and you'll be refunded the difference.
          </p>
        </div>
      </DialogContent>
      <DialogCTA className={"flex flex-col gap-2 md:flex-row"}>
        <>
          {(productName || isStorefront) && (
            <Button
              color={"tertiary"}
              className={"w-full md:w-auto"}
              onClick={() => window.open(url, "_blank")}
            >
              Don't see the best price?
            </Button>
          )}
        </>
      </DialogCTA>
    </Dialog>
  );
};
